'use client';

import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { CatButton } from 'components/blocks-components';
import { useRequestEquipmentService } from 'components/request-equipment-service/request-equipment-service-context';
import { useTranslations } from 'next-intl';

const RequestInfoButton = () => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const { setIsRSModalOpen } = useRequestEquipmentService();
  return (
    <CatButton
      className="cat-u-margin-top-md cat-u-margin-right-md cat-u-margin-bottom-md"
      variant="contrast"
      size={isMD ? 'sm' : 'md'}
      onClick={() => setIsRSModalOpen(true)}
    >
      {t('PDP_REQUEST_INFORMATION')}
    </CatButton>
  );
};

export default RequestInfoButton;
